/**
 * @architecture-header 1
 * @layer routes
 * @domain workspace-shell
 * @responsibility Render the single transient notice the workspace shows after an action.
 * @state-owner navigation store
 * @allowed-imports React; workspace store
 * @forbidden business rules; network
 * @public-api WorkspaceShell
 * @side-effects schedules a dismissal timer
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { useEffect } from 'react';
import { useWorkspaceUiStore } from '../../shared/model/workspace-store';

export function Toast() {
  const notice = useWorkspaceUiStore((state) => state.notice);
  const clearNotice = useWorkspaceUiStore((state) => state.clearNotice);

  useEffect(() => {
    if (!notice) return;
    const timeout = window.setTimeout(clearNotice, 1700);
    return () => window.clearTimeout(timeout);
  }, [clearNotice, notice]);

  if (!notice) return null;
  return (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 86,
        transform: 'translateX(-50%)',
        background: '#1c1b1c',
        color: '#fff',
        padding: '12px 20px',
        borderRadius: 12,
        fontSize: 15,
        zIndex: 99,
        boxShadow: '0 12px 34px rgba(0,0,0,.22)',
      }}
    >
      {notice}
    </div>
  );
}
